import { JSX } from 'react'

import { IconProps } from '../../icon'

const Pending: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M36.6504 31.7926C36.0964 31.3805 35.3134 31.4956 34.9014 32.0494C34.6747 32.354 34.4322 32.6528 34.1805 32.9375C33.7234 33.4547 33.7719 34.2447 34.2891 34.7019C34.527 34.9122 34.8223 35.0154 35.1165 35.0154C35.4623 35.0154 35.8065 34.8727 36.0535 34.5933C36.3516 34.2562 36.6388 33.9023 36.9072 33.5415C37.3192 32.9877 37.2043 32.2046 36.6504 31.7926Z'
      fill='black'
    />
    <path
      d='M38.7409 25.9304C38.0667 25.7836 37.4004 26.2114 37.2536 26.8859C37.1728 27.2569 37.0752 27.6287 36.9632 27.9909C36.7594 28.6506 37.1289 29.3504 37.7885 29.5543C37.9114 29.5922 38.0357 29.6103 38.1579 29.6103C38.6917 29.6103 39.1859 29.2656 39.3518 28.7289C39.4847 28.299 39.6006 27.8578 39.6964 27.4176C39.8432 26.7431 39.4154 26.0773 38.7409 25.9304Z'
      fill='black'
    />
    <path
      d='M30.6337 35.7959C30.3018 35.9811 29.9582 36.1543 29.6124 36.3104C28.9832 36.5946 28.7035 37.3349 28.9877 37.9641C29.1964 38.4264 29.6514 38.6999 30.1276 38.6999C30.2996 38.6999 30.4744 38.6642 30.6414 38.5889C31.0515 38.4036 31.4589 38.1983 31.8524 37.9786C32.4552 37.6421 32.671 36.8806 32.3344 36.2779C31.998 35.6752 31.2365 35.4594 30.6337 35.7959Z'
      fill='black'
    />
    <path
      d='M22.75 14V23.4823L18.1663 28.0659C17.6782 28.5541 17.6782 29.3455 18.1663 29.8336C18.4105 30.0778 18.7303 30.1998 19.0503 30.1998C19.3701 30.1998 19.6901 30.0777 19.9342 29.8336L24.884 24.8839C25.1183 24.6495 25.25 24.3315 25.25 24V14C25.25 13.3096 24.6904 12.75 24 12.75C23.3096 12.75 22.75 13.3096 22.75 14Z'
      fill='black'
    />
    <path
      d='M38.75 10.6875C38.0596 10.6875 37.5 11.2471 37.5 11.9375V15.4085C34.5905 10.8455 29.5094 8 24 8C19.7262 8 15.7083 9.66431 12.6863 12.6863C9.66431 15.7083 8 19.7262 8 24C8 28.2738 9.66431 32.2917 12.6863 35.3137C15.7083 38.3357 19.7262 40 24 40C24.0106 40 24.0208 39.9987 24.0312 39.9984C24.0417 39.9987 24.0519 40 24.0625 40C24.513 40 24.9679 39.981 25.4148 39.9436C26.1027 39.886 26.6137 39.2816 26.5562 38.5937C26.4985 37.9058 25.8949 37.3945 25.2062 37.4524C24.8284 37.4839 24.4437 37.5 24.0625 37.5C24.0519 37.5 24.0417 37.5013 24.0312 37.5016C24.0208 37.5013 24.0106 37.5 24 37.5C16.5561 37.5 10.5 31.4439 10.5 24C10.5 16.5561 16.5561 10.5 24 10.5C28.7974 10.5 33.2098 13.0571 35.621 17.125H32.1839C31.4936 17.125 30.9339 17.6846 30.9339 18.375C30.9339 19.0654 31.4936 19.625 32.1839 19.625H36C36.7612 19.625 37.4734 19.4111 38.0798 19.0404C38.1188 19.0182 38.1563 18.9942 38.1921 18.9684C39.2799 18.2527 40 17.0217 40 15.625V11.9375C40 11.2471 39.4404 10.6875 38.75 10.6875Z'
      fill='black'
    />
  </svg>
)

export default Pending
